export default __webpack_public_path__ + "static/logo-color-c710acdec93099ff2d3619b9825ee607.svg";